import { buildNow } from './buildNow';
import type { DateTimeSettings } from './types';
import { MS_IN_DAY } from '../../shared/constants';

const dayIndex = (d: Date) => Math.floor(d.getTime() / MS_IN_DAY);

const calculateDayDifference = (date: Date, settings: DateTimeSettings): number => {
    const now = buildNow(settings);

    return dayIndex(date) - dayIndex(now);
};


export {
    calculateDayDifference,
}
